import { company, translations } from "@/config/content";

const waBase = `https://wa.me/${company.whatsapp}`;

// Opens WhatsApp with an arbitrary pre-filled message.
export function openWhatsApp(message) {
  const url = `${waBase}?text=${encodeURIComponent(message)}`;
  window.open(url, "_blank", "noopener");
}

// Generic emergency message (no location).
export function emergencyMessage(lang = "it") {
  if (lang === "en") {
    return `Hi EMME SERVICE CAR, I need roadside assistance.

🚗 Vehicle:
[TO FILL]

⚠️ Issue:
[TO FILL]

👤 Name:
[TO FILL]

Can you call me back?`;
  }
  return `Ciao EMME SERVICE CAR, ho bisogno di soccorso stradale.

🚗 Veicolo:
[DA COMPILARE]

⚠️ Problema:
[DA COMPILARE]

👤 Nome:
[DA COMPILARE]

Potete ricontattarmi?`;
}

// Message including a Google Maps location link.
function locationMessage(mapsLink, lang = "it") {
  if (lang === "en") {
    return `Hi EMME SERVICE CAR, I need roadside assistance.

📍 This is my location:
${mapsLink}

🚗 Vehicle:
[TO FILL]

⚠️ Issue:
[TO FILL]

👤 Name:
[TO FILL]

Can you call me back?`;
  }
  return `Ciao EMME SERVICE CAR, ho bisogno di soccorso stradale.

📍 Questa è la mia posizione:
${mapsLink}

🚗 Veicolo:
[DA COMPILARE]

⚠️ Problema:
[DA COMPILARE]

👤 Nome:
[DA COMPILARE]

Potete ricontattarmi?`;
}

// Requests browser geolocation and opens WhatsApp with a Google Maps link.
export function sendLocationToWhatsApp({ lang = "it", onError, onStart } = {}) {
  if (!("geolocation" in navigator)) {
    onError?.(translations[lang].locationError);
    return;
  }
  onStart?.();
  navigator.geolocation.getCurrentPosition(
    (pos) => {
      const { latitude, longitude } = pos.coords;
      const mapsLink = `https://www.google.com/maps?q=${latitude},${longitude}`;
      openWhatsApp(locationMessage(mapsLink, lang));
    },
    () => {
      onError?.(translations[lang].locationError);
    },
    { enableHighAccuracy: true, timeout: 10000, maximumAge: 0 }
  );
}

// Builds a scheduled-transport summary message for WhatsApp.
export function quoteSummaryMessage(data, lang = "it") {
  const q = translations[lang].quote;
  if (lang === "en") {
    return `Hi EMME SERVICE CAR, I'd like a transport quote.

🚚 Vehicle: ${data.vehicleType || "-"}
📍 From: ${data.origin || "-"}
🏁 To: ${data.destination || "-"}
📅 When: ${data.timing || "-"}${data.date ? " (" + data.date + ")" : ""}
🔧 Condition: ${data.condition || "-"}
👤 Name: ${data.name || "-"}
📞 Phone: ${data.phone || "-"}
${data.notes ? "📝 Notes: " + data.notes : ""}`;
  }
  return `Ciao EMME SERVICE CAR, vorrei un preventivo per un trasporto.

🚚 Veicolo: ${data.vehicleType || "-"}
📍 Partenza: ${data.origin || "-"}
🏁 Destinazione: ${data.destination || "-"}
📅 Quando: ${data.timing || "-"}${data.date ? " (" + data.date + ")" : ""}
🔧 Condizioni: ${data.condition || "-"}
👤 Nome: ${data.name || "-"}
📞 Telefono: ${data.phone || "-"}
${data.notes ? "📝 Note: " + data.notes : ""}`;
}
